import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { getLoginPath } from '../utils/authRedirect';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedUserTypes?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  allowedUserTypes 
}) => {
  const { token, user } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  if (!token || !user) {
    const redirectPath = getLoginPath(null, location.pathname);
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const currentTime = Date.now() / 1000;
    
    if (payload.exp < currentTime) {
      // Token expired - redirect to appropriate login page based on user type
      const redirectPath = getLoginPath(user.userType as 'student' | 'tutor');
      return <Navigate to={redirectPath} state={{ from: location }} replace />;
    }
  } catch (error) {
    // Invalid token - use centralized logic
    const redirectPath = getLoginPath(null, location.pathname);
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  if (allowedUserTypes && !allowedUserTypes.includes(user.userType)) {
    if (user.userType === 'tutor') {
      return <Navigate to="/TutorDashboard" replace />;
    } else if (user.userType === 'student') {
      return <Navigate to="/StudentDashboard" replace />;
    }
  }

  return <>{children}</>;
};
